import React from 'react';
import { useSelector } from 'react-redux';
import ConfirmDialogue from './ConfirmDialogue';

// HACK: Ideally this should be with RootModal, but as we would have some modal stacking issues it is separated for now
// We should make the changes to RootModal for stacking instead,
// as that might be a breaking change we will deal with this later in a separate ticket

const ConfirmDialogRoot = () => {
  const { props } = useSelector(({ confirmDialog }) => confirmDialog);
  return <ConfirmDialogue {...props} />;
};

export default ConfirmDialogRoot;
